import React from "react";
import Partner from "../../types/Partner";
import { Table } from "./styles/resultsStyles";
import TableContent from "./tableContent/TableContent";
import TableHeader from "./tableHeader/TableHeader";

interface ResultsListProps {
  singleMarkerResult?: Partner;
  queryResults?: Partner[];
}

const ResultsList = (props: ResultsListProps) => {
  const { singleMarkerResult, queryResults } = props;

  return (
    <Table>
      <TableHeader />
      <TableContent
        singleMarkerResult={singleMarkerResult}
        queryResults={queryResults}
      />
    </Table>
  );
};

export default ResultsList;
